import ApiService, { callCustomMethodAsync } from '../service/ApiService';

let moduleApi = {};
let moduleName = "company";

moduleApi.create = async (dataForm) => {
 let api = {
    module: moduleName,
    type: "create",
    value: dataForm,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.update = async (dataForm) => {
  let api = {
    module: moduleName,
    type: "partialUpdate",
    value: dataForm,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.list = async (dataFilter, loading) => {
  let api = {
    module: moduleName,
    type: "list",
    value: dataFilter,
    dontLoading: (loading == undefined ? false : loading),
  };
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.delete = async (id, loading) => {
  let api = {
    module: moduleName,
    type: "delete",
    value: { id: id },
    dontLoading: (loading == undefined ? false : loading),
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.findById = async (id, loading) => {
  let api = {
    module: moduleName,
    type: "findById",
    value: { id: id },
    dontLoading: (loading == undefined ? false : loading),
  };
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};
moduleApi.SyncDataToTimwookEnt = async () => {
  let api = {
    module: moduleName,
    type: "SyncDataToTimwookEnt",
    message: {
      success: "Đồng bộ thành công", //string | null | comment
      error: "Đồng bộ thất bại", //string | null | comment
    },
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.LockCompany = async (data) => {
  let api = {
    module: moduleName,
    body: data,
    type: "LockCompany",
    message: {
      success: "Khóa công ty thành công", //string | null | comment
      error: "Khóa công ty thất bại", //string | null | comment
    },
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.UnLockCompany = async (data) => {
  let api = {
    module: moduleName,
    body: data,
    type: "UnLockCompany",
    message: {
      success: "Mở khóa công ty thành công", //string | null | comment
      error: "Mở khóa công ty thất bại", //string | null | comment
    },
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.SearchCompany = async (text) => {
  let api = {
    module: moduleName,
    body: { text_search: text },
    type: "SearchCompany",
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.GetCompanyTree = async (data = {}) => {
  let api = {
    module: moduleName,
    body: data,
    type: "GetCompanyTree",
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.GetCompanyFilterOptions = async (data = {}) => {
  let api = {
    module: moduleName,
    body: data,
    type: "GetCompanyFilterOptions",
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.UpdateCompanyHierarchy = async (data) => {
  let api = {
    module: moduleName,
    body: data,
    type: "UpdateCompanyHierarchy",
    message: {
      success: "Cập nhật phân cấp công ty thành công",
      error: "Cập nhật phân cấp công ty thất bại"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.GetAnnualLeavePolicy = async (data = {}) => {
  let api = {
    module: moduleName,
    body: data,
    type: "GetAnnualLeavePolicy",
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.SaveAnnualLeavePolicyDraft = async (data) => {
  let api = {
    module: moduleName,
    body: data,
    type: "SaveAnnualLeavePolicyDraft",
    message: {
      success: "Lưu nháp cấu hình nghỉ phép thành công",
      error: "Lưu nháp cấu hình nghỉ phép thất bại"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.ActivateAnnualLeavePolicy = async (data) => {
  let api = {
    module: moduleName,
    body: data,
    type: "ActivateAnnualLeavePolicy",
    message: {
      success: "Áp dụng chính sách nghỉ phép thành công",
      error: "Áp dụng chính sách nghỉ phép thất bại"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.EndAnnualLeavePolicy = async (data) => {
  let api = {
    module: moduleName,
    body: data,
    type: "EndAnnualLeavePolicy",
    message: {
      success: "Kết thúc chính sách nghỉ phép thành công",
      error: "Kết thúc chính sách nghỉ phép thất bại"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
};

export default moduleApi;
